module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_sami-maunu_A4.17f0a2c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_sami-maunu_A4.pdf
// module id = dMlC
// module chunks = 22